import React from 'react';
import { Button } from "./";
import useDataAccessDownload from '../../Hooks/useDataAccessDownload';
import { saveBlob } from '../../Utils/fileDownloadUtils';
import { enableDataAccessApi } from '../../Utils/features';
import { FRONT_END_ASSETS } from '../../Constants/dataAccessFileCategories';

function PDFDownloadButton({ fileName, buttonText, onError, onClick, className }) {
    const {
        loading: downloadLoading,
        error: downloadError,
        execute: downloadExecute,
        reset: downloadReset
    } = useDataAccessDownload();

    const handlePDFDownload = async () => {
        try {
            downloadReset();
            const downloadResult = await downloadExecute(FRONT_END_ASSETS, fileName);
            if (downloadError) {
                throw new Error(downloadError);
            }
            const blob = new Blob([downloadResult], { type: 'application/pdf' });
            saveBlob(blob, fileName);
        } catch (error) {
            onError?.(error.message);
        }
    };

    const buttonClassName = className || 'btn-outline-secondary';

    return (
        enableDataAccessApi ?
            <Button
                className={`btn ${buttonClassName}`}
                onClick={() => {
                    onClick?.();
                    handlePDFDownload();
                }}
                disabled={downloadLoading}
                loading={downloadLoading}
                text={buttonText}/>
        :
            <Button className={`btn ${buttonClassName}}`}
                text={buttonText}
                onClick={() => window.open(fileName, "_blank")}/>
    );
}

export default PDFDownloadButton;
